'use client';

import { If, SplitScreenComponent } from '@payments-checkout/shared/components';
import { env } from 'next-runtime-env';
import { ReactElement, createElement, useEffect, useState } from 'react';
import { Replace } from '../../../app/components/replace';
import { usePageSharedData } from '../../../hooks/usePageSharedData';
import { LoadingState } from '../../loading';
import { CardCreditCardAddress } from '../cardAddress/creditCardAddress';
import { CheckoutDetailsPage } from '../checkoutDetailsPage/checkoutDetailsPage';

export function PaymentInformationPage() {
  const {
    isReady,
    paymentLinkIdData,
    hasInvalidPaymentSelected,
  } = usePageSharedData();
  const [element, setElement] = useState<ReactElement>();
  const [authSwitchElement, setAuthSwitchElement] = useState<ReactElement>();

  useEffect(() => {
    setElement(
      createElement('script', {
        src: env('NEXT_PUBLIC_URL_3DS'),
        async: true,
      })
    );
    setAuthSwitchElement(
      createElement('script', {
        src: env('NEXT_PUBLIC_URL_AUTHSWITCH'),
        async: true,
      })
    );
  }, []);

  if (hasInvalidPaymentSelected) return <Replace />;
  if (paymentLinkIdData.isLoading) return <LoadingState fullPage />;
  return (
    <If condition={isReady}>
      {element}
      {authSwitchElement}
      <div id="challengeContainer" />
      <SplitScreenComponent
        leftContent={<CardCreditCardAddress />}
        rightContent={
          <CheckoutDetailsPage
            accountName={paymentLinkIdData.data?.account_settings.account_name}
            displayName={paymentLinkIdData.data?.account_settings.display_name}
            organization={paymentLinkIdData.data?.account_settings.organization}
            screen="dados_cobranca"
          />
        }
      />
    </If>
  );
}
